import { combineReducers } from '@reduxjs/toolkit'
import { persistedAuthUserReducer } from './reducer/authReducer'
import { persistedSessionReducer } from './reducer/sessionReducer'
import toastSlice from './slices/toast.slice'
import loaderSlice from './slices/loader.slice'
import entitySlice from './slices/entity.slice'
import ndcCodesSlice from './slices/ndcCodes.slice'
import productPricingSlice from './slices/productPricing.slice'
import cptCodeSlice from './slices/cptCode.slice'
import hcpcsCodeSlice from './slices/hcpcsCode.slice'
import compendiaSlice from './slices/compendia.slice'
import approvedIndicationSlice from './slices/approvedIndication.slice'
import navigationSlice from './slices/navigation.slice'
import addProductSlice from './slices/addProduct.slice'
import userlistSlice from './slices/userlist.slice'
import roleSlice from './slices/role.slice'
import clientconfigSlice from './slices/clientconfig.slice'
import layoutSlice from './slices/layout.slice'
import programSlice from './slices/program.slice'
import permissionsSlice from './slices/permissions.slice'
import tableColumnSlice from './slices/tableColumn.slice'
import programDetailsSlice from './slices/Holiday.slice'
import macrosSlice from './slices/macros.slice'
import documentTemplateSlice from './slices/documentTemplate.slice'
import hcpPortalSlice from './slices/hcpPortal.slice'
import templateManagerSlice from './slices/templateManager.slice'
import auditSlice from './slices/audit.slice'
import manualCommunicationSlice from './slices/manualCommuication.slice'
import programWorkingHoursSlice from './slices/programWorkingHours.slice'
import hcpOnboardingSlice from './slices/hcpOnboarding.slice'
import hcpConsentSlice from './slices/hcpConsent.slice'
import correspondenceLogsSlice from './slices/correspondenceLogs.slice'
import callInteractionSlice from './slices/callInteraction.slice'
import view360Slice from './slices/view360.slice'
import clientPermissionsSlice from './slices/clientPermissions.slice'
import slaManagementSlice from './slices/slaManagement.slice'
import hcpEnrollmentFlowSlice from './slices/hcpEnrollmentFlow.slice'
import hcpAuthSlice from './slices/hcpAuth.slice'
import serviceRequestedSlice from './slices/serviceRequested.slice'
import authRememberSlice from './slices/userRemember.slice'
import queueCreationSlice from './slices/queueCreation.slice'
import permissionSlice from './slices/permissions.slice'
import tablePaginationSlice from './slices/pagination.slice'
import notificationSlice from './slices/notifications.slice'
import allPermissionsSlice from './slices/allPermissions.slice'
import workflowSlice from './slices/workflow.slice'
import categorySlice from './slices/categoryDropdown.slice'
import appStateSlice from './slices/appState.slice'
import clientProgramSlice from './slices/clientProgram.slice'
import contextualSlice from './slices/contextualFiltering.slice'
import webConsentSlice from './slices/webConsent.slice'
import showPdfinLeftPaneSlice from './slices/showPdfInLeftPane.slice'
import workflowTaskStatusSlice from './slices/workflowTaskStatus.slice'
import localCommonSlice from './slices/localCommon.slice'
import mecPortalSlice from './slices/mecPortal.slice'
import patientDataSlice from './slices/patientData.slice'
import awsCallSlice from './slices/awsCall.slice'
import maxRteSlice from './slices/maxRTE.slice'
import clientDropdownSlice from './slices/clientDropdown.slice'
import layoutBuilderSlice from './slices/layoutBuilder.slice'
import ruleConfigSlice from './slices/ruleConfig.slice'
import customEventSlice from './slices/customEvent.slice'
import updateEntitySlice from './slices/updateEntity.slice'
import tabUISlice from './slices/tabUI.slice'
import requestorSlice from './slices/requestor.slice'

export const getAdminPortalReducers = () => {
  return combineReducers({
    authUser: persistedAuthUserReducer,
    session: persistedSessionReducer,
    toaster: toastSlice,
    loader: loaderSlice,
    entities: entitySlice,
    ndcCodes: ndcCodesSlice,
    productPricing: productPricingSlice,
    cptCode: cptCodeSlice,
    hcpcsCode: hcpcsCodeSlice,
    correspondenceLogs: correspondenceLogsSlice,
    compendia: compendiaSlice,
    approvedIndication: approvedIndicationSlice,
    navigation: navigationSlice,
    addProducts: addProductSlice,
    userlist: userlistSlice,
    role: roleSlice,
    clientConfig: clientconfigSlice,
    layout: layoutSlice,
    program: programSlice,
    permissions: permissionsSlice,
    tableColumn: tableColumnSlice,
    programHolidays: programDetailsSlice,
    documentTemplate: documentTemplateSlice,
    // emailTemplate: emailTemplateSlice,
    macros: macrosSlice,
    hcp: hcpPortalSlice,
    hcpConsent: hcpConsentSlice,
    templateManager: templateManagerSlice,
    audit: auditSlice,
    manualCommunication: manualCommunicationSlice,
    programWorkingHours: programWorkingHoursSlice,
    clientPermissions: clientPermissionsSlice,
    view360: view360Slice,
    slaManagement: slaManagementSlice,
    serviceRequested: serviceRequestedSlice,
    pagination: tablePaginationSlice,
    notificationTemplate: notificationSlice,
    allPermissions: allPermissionsSlice,
    mec: mecPortalSlice,
    clientDropdownState: clientDropdownSlice,
    layoutBuilder: layoutBuilderSlice,
    ruleConfiguration: ruleConfigSlice,
  })
}

export const getAgentPortalReducers = () => {
  return combineReducers({
    authUser: persistedAuthUserReducer,
    session: persistedSessionReducer,
    correspondenceLogs: correspondenceLogsSlice,
    tableColumn: tableColumnSlice,
    toaster: toastSlice,
    loader: loaderSlice,
    entity: entitySlice,
    navigation: navigationSlice,
    callInteraction: callInteractionSlice,
    queueCreation: queueCreationSlice,
    permissions: permissionSlice,
    appState: appStateSlice,
    clientPermissions: clientPermissionsSlice,
    workflowData: workflowSlice,
    categoryDropdown: categorySlice,
    clientPrograms: clientProgramSlice,
    pagination: tablePaginationSlice,
    contextual: contextualSlice,
    pdfData: showPdfinLeftPaneSlice,
    workflowTaskStatus: workflowTaskStatusSlice,
    localCommon: localCommonSlice,
    patientData: patientDataSlice,
    awsCall: awsCallSlice,
    tabUI: tabUISlice,
    maxRte: maxRteSlice,
    allPermissions: allPermissionsSlice,
    clientDropdownState: clientDropdownSlice,
    customEvent: customEventSlice,
    updatedEntityData: updateEntitySlice,
    requestor: requestorSlice,
  })
}

export const getHcpPortalReducers = () => {
  return combineReducers({
    toaster: toastSlice,
    loader: loaderSlice,
    navigation: navigationSlice,
    hcpOnboarding: hcpOnboardingSlice,
    authUser: persistedAuthUserReducer,
    session: persistedSessionReducer,
    hcpEnrollmentFlow: hcpEnrollmentFlowSlice,
    hcpAuth: hcpAuthSlice,
    serviceRequested: serviceRequestedSlice,
    authRemember: authRememberSlice,
    hcpConsent: hcpConsentSlice,
  })
}

export const getWebConsentPortalReducers = () => {
  return combineReducers({
    toaster: toastSlice,
    loader: loaderSlice,
    navigation: navigationSlice,
    webConsent: webConsentSlice,
    hcpOnboarding: hcpOnboardingSlice,
  })
}
